import { css } from '@emotion/css';

export const offsetClassName = css({
  '&:last-of-type': {
    width: '75% !important',
  },
});
